import styled from "styled-components/macro";

export const Title = styled.h2`
  text-align: center;
`;

export const HomePage = styled.div`
  padding: 0 15px;
`;
